Application.Postcard.Postcard = {
    ui: {
        container: '.js-postcard',
        fields: {
            message: '.js-postcard__message',
            name: '.js-postcard__name',
            company: '.js-postcard__company',
            street: '.js-postcard__street',
            city: '.js-postcard__city',
            country: '.js-postcard__country',
            zip: '.js-postcard__zip',
        }
    },
    setMessage: function(value){

        $(this.ui.fields.message).text(value);

    },
    setName: function(value1, value2){

        if (value2){
            $(this.ui.fields.name).empty()
                                .append($('<span />').text(value1))
                                .append($('<br />'))
                                .append($('<span />').text(value2));
        }else{
            $(this.ui.fields.name).text(value1);
        }

    },
    setCompany: function(value){

        $(this.ui.fields.company).text(value);

    },
    setStreet: function(value){

        $(this.ui.fields.street).text(value);

    },
    setCity: function(value){

        $(this.ui.fields.city).text(value);

    },
    setCountry: function(value){

        $(this.ui.fields.country).text(value);

    },
    setZip: function(value){

        var self = this;

        $(this.ui.fields.zip).empty();

        _.each(value.split(''), function(char){
            $(self.ui.fields.zip).append($('<span />').text(char));
        });

    },
};